/* eslint-disable react/no-multi-comp */
import React, { useMemo } from 'react'
import { FormattedNumber, FormattedDate } from 'react-intl'
import { type RowInfo } from 'react-table'
import { StoreGroupsListTableEditButton } from 'legacy/sections/store-groups/components/list/components/StoreGroupsListEditButton'
import { StoreGroupsListTableDeleteButton } from 'legacy/sections/store-groups/components/list/components/StoreGroupsListDeleteButton'
import { type StoreGroup } from 'legacy/common/graphql-types/retailerLocationGroup.types'

export interface StoreGroupsTableRowInfo extends RowInfo {
  original: StoreGroup
}

interface useStoreGroupListTableColumns {
  onEditClicked?: (storeGroupId: string) => void
}

export const useStoreGroupListTableColumns = ({ onEditClicked }) =>
  useMemo(
    () => [
      {
        header: 'ID',
        accessor: 'id',
      },
      {
        header: 'Name',
        accessor: 'name',
      },
      {
        header: '# of Stores',
        Cell: ({ original: { retailerLocationIds } }: StoreGroupsTableRowInfo) => (
          <FormattedNumber value={retailerLocationIds.length} />
        ),
      },
      {
        header: 'Last Edited',
        Cell: ({ original: { updatedAt } }: StoreGroupsTableRowInfo) => (
          <FormattedDate value={updatedAt} />
        ),
      },
      {
        Header: () => null,
        width: 40,
        Cell: ({ original: { id } }: StoreGroupsTableRowInfo) => (
          <StoreGroupsListTableEditButton storeGroupId={id} onEditClicked={onEditClicked} />
        ),
      },
      {
        Header: () => null,
        width: 40,
        Cell: ({ original }: StoreGroupsTableRowInfo) => (
          <StoreGroupsListTableDeleteButton storeGroup={original} />
        ),
      },
    ],
    [onEditClicked]
  )
